/**
 * Part del State necessari perl popup de la fitxa urbanística
 * Component: FitxUrbPopUp.ts
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 26/04/2022
 * (c) Ajuntament de Manresa - abr 2022 - Departament de Sistemes d'Informació
 */

import OlOverlay from 'ol/Overlay';
import { Coordinate } from 'ol/coordinate';
import Util from '../config/util';

export default class FitxUrbPopUp {

    // Posa el contingut del Popup d'informació d'un element
    public static setPoupContent(c: Coordinate, content: string, popupContent: HTMLDivElement, popupOverlay: OlOverlay, entorn: string): void {
        let txElem = '', codi = '', nom = '', enllac = '', prot = '', tipus = '', tramit = '', aprov = '', observ = '', categ = '', pesp = '', enllacpe = '', resum = '', parti = '', vigent = ''; // area = '', perim = ''
        let flag = false;
        let txHtml = '';
        const pos = { pos: 0 };
        let oldPos = 0;
        let elcata = '';

        // content = content.replace(/\s+/g, ' ').trim(); // Traiem els retorns de carro, tabuladors, ...
        // Construim el títol
        const txHtmlTit = '<h2><b>Informació</b></h2><hr/>';
        // Construim el cos
        // PARCEL·LA URBANA
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLPARCESEL", "</PLPARCESEL>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<FINREFCAD1>", "</FINREFCAD1>", txElem) + " " + Util.getBetweenI("<FINREFCAD2>", "</FINREFCAD2>", txElem);
            txHtml += "<h2>" + codi + "</h2><br />";
        } else { pos.pos = oldPos; }

        // PARCEL·LA RUSTICA
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLRPARCESEL", "</PLRPARCESEL>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<FINREFCAD1>", "</FINREFCAD1>", txElem) + " " + Util.getBetweenI("<FINREFCAD2>", "</FINREFCAD2>", txElem);
            txHtml += "<h2>" + codi + "</h2><br />";
        } else { pos.pos = oldPos; }

        // CLASSIFICACIO
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLCLASSI17", "</PLCLASSI17>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<CLASSI>", "</CLASSI>", txElem);
            nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
//            area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//            perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
            txHtml += "<h2>Classificaci&oacute; del s&ograve;l</h2>" +
                codi + " - " + nom + "<br />";
//            txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />"M
//            txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
            txHtml += "<br />";
        } else { pos.pos = oldPos; }

        // SOL URBÀ NO CONSOLIDAT
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLSUNC17", "</PLSUNC17>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<CLASSI>", "</CLASSI>", txElem);
            nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
//            area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//            perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
            txHtml += "<h2>S&ograve;l urb&agrave; no consolidat</h2>" +
                codi + " - " + nom + "<br />";
//            txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />"M
//            txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
            txHtml += "<br />";
        } else { pos.pos = oldPos; }

        // QUALIFICACIO
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLQUALIF17", "</PLQUALIF17>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<QUALIF>", "</QUALIF>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                const condus = Util.getBetweenI("<CONDUS>", "</CONDUS>", txElem);
                const enllacus = Util.getBetweenI("<ENLLACUS>", "</ENLLACUS>", txElem);
                const tipused = Util.getBetweenI("<TIPUSED>", "</TIPUSED>", txElem);
                const enllaced = Util.getBetweenI("<ENLLACED>", "</ENLLACED>", txElem);
                const edifmax = Number(Util.getBetweenI("<EDIFMAX>", "</EDIFMAX>", txElem));
                const ocupmax = Number(Util.getBetweenI("<OCUPMAX>", "</OCUPMAX>", txElem));
                const sepllind = Util.getBetweenI("<SEPLLIND>", "</SEPLLIND>", txElem);
    //            area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
    //            perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                txHtml += "<h2>Qualificaci&oacute; del s&ograve;l</h2>";
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                    if (condus > "") {
                        if (enllacus > "")
                            txHtml += "<table><tr><td style='width: 20px'></td><td style='width: 480px'><div style='font-size:x-small; text-align:justify'><a href='#' onclick='window.open(\"" + enllacus + "\")'><span style='color: blue; text-decoration:underline;'>Condicions d'&uacute;s:</span></a> " + condus + "</div></td></tr></table>";
                        else
                            txHtml += "<table><tr><td style='width: 20px'></td><td style='width: 480px'><div style='font-size:x-small; text-align:justify'><b>Condicions d'&uacute;s:</b> " + condus + "</div></td></tr></table>";
                    }
                    if (tipused > "") {
                        if (enllaced > "")
                            txHtml += "<table><tr><td style='width: 20px'></td><td style='width: 480px'><div style='font-size:x-small; text-align:justify'><a href='#' onclick='window.open(\"" + enllaced + "\")'><span style='color: blue; text-decoration:underline;'>Tipus d'edificaci&oacute;:</span></a> " + tipused + "</div></td></tr></table>";
                        else
                            txHtml += "<table><tr><td style='width: 20px'></td><td style='width: 480px'><div style='font-size:x-small; text-align:justify'><b>Tipus d'edificaci&oacute;:</b> " + tipused + "</div></td></tr></table>";
                    }
                    if (edifmax > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;Edificabilitat m&agrave;xima : " + edifmax.toFixed(2) + " m<sup>2</sup>sostre/m<sup>2</sup>s&ograve;l<br />";
                if (ocupmax > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;Ocupaci&oacute; m&agrave;xima : " + ocupmax.toFixed(2) + " %<br />";
                if (sepllind > "")
                    txHtml += '&nbsp;&nbsp;&nbsp;&nbsp;Separaci&oacute; llindars : ' + sepllind + '<br />';
    //            txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
    //            txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
        } else { pos.pos = oldPos; }

        // ALÇADA
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLCONDIC17", "</PLCONDIC17>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<CONDIC>", "</CONDIC>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                txHtml += "<h2>Condici&oacute; d'edificaci&oacute;</h2>";
                txHtml += codi + " - " + nom + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
        } else { pos.pos = oldPos; }

        // AMBIT
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLAMBIT17", "</PLAMBIT17>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<CODI>", "</CODI>", txElem);
            nom = Util.getBetweenI("<DENOM>", "</DENOM>", txElem);
            enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//            area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
            const viari = Number(Util.getBetweenI("<VIARI>", "</VIARI>", txElem));
            const lliure = Number(Util.getBetweenI("<LLIURE>", "</LLIURE>", txElem));
            const equipaments = Number(Util.getBetweenI("<EQUIPAMENTS>", "</EQUIPAMENTS>", txElem));
            const solprivat = Number(Util.getBetweenI("<SOLPRIVAT>", "</SOLPRIVAT>", txElem));
            const edifbrut = Number(Util.getBetweenI("<EDIFBRUT>", "</EDIFBRUT>", txElem));
            const denshab = Number(Util.getBetweenI("<DENSHAB>", "</DENSHAB>", txElem));
            const us = Util.getBetweenI("<US>", "</US>", txElem);
//            perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
            txHtml += "<h2>&Agrave;mbit de desenvolupament</h2>";
            if (enllac > "")
                txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
            else
                txHtml += codi + " - " + nom + "<br />";
//            txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//            txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
const solpublic = viari + lliure + equipaments;
            if (solpublic > 0.0) {
                txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;S&ograve;l p&uacute;blic : " + solpublic.toFixed(2) + " %<br />";
                if (viari > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Viari : " + viari.toFixed(2) + " %<br />";
                if (lliure > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Espais lliures : " + lliure.toFixed(2) + " %<br />";
                if (equipaments > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Equipaments : " + equipaments.toFixed(2) + " %<br />";
            }
            if (solprivat > 0.0 || edifbrut > 0.0 || denshab > 0.0 || us > "") {
                txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;S&ograve;l d'aprofitament privat" + (solprivat > 0.0 ? " : " + solprivat.toFixed(2) + " %<br />" : "<br />");
                if (edifbrut > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edificabilitat bruta m&agrave;xima : " + edifbrut.toFixed(2) + " m<sup>2</sup>sostre/m<sup>2</sup>s&ograve;l<br />";
                if (denshab > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Densitat m&agrave;xima d'habitatges : " + denshab.toFixed(2) + " hab/ha<br />";
                if (us > "")
                    txHtml += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&Uacute;s global : ' + us + '<br />';
            }
            txHtml += "<br />";
        } else { pos.pos = oldPos; }

        // AMBIT2
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLAMBIT217", "</PLAMBIT217>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<CODI>", "</CODI>", txElem);
            nom = Util.getBetweenI("<DENOM>", "</DENOM>", txElem);
            enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//            area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
            const viari = Number(Util.getBetweenI("<VIARI>", "</VIARI>", txElem));
            const lliure = Number(Util.getBetweenI("<LLIURE>", "</LLIURE>", txElem));
            const equipaments = Number(Util.getBetweenI("<EQUIPAMENTS>", "</EQUIPAMENTS>", txElem));
            const solprivat = Number(Util.getBetweenI("<SOLPRIVAT>", "</SOLPRIVAT>", txElem));
            const edifbrut = Number(Util.getBetweenI("<EDIFBRUT>", "</EDIFBRUT>", txElem));
            const denshab = Number(Util.getBetweenI("<DENSHAB>", "</DENSHAB>", txElem));
            const us = Util.getBetweenI("<US>", "</US>", txElem);
//            perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
            txHtml += "<h2>&Agrave;mbit de desenvolupament integrat</h2>";
            if (enllac > "")
                txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
            else
                txHtml += codi + " - " + nom + "<br />";
//            txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//            txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
            const solpublic = viari + lliure + equipaments;
            if (solpublic > 0.0) {
                txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;S&ograve;l p&uacute;blic : " + solpublic.toFixed(2) + " %<br />";
                if (viari > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Viari : " + viari.toFixed(2) + " %<br />";
                if (lliure > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Espais lliures : " + lliure.toFixed(2) + " %<br />";
                if (equipaments > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Equipaments : " + equipaments.toFixed(2) + " %<br />";
            }
            if (solprivat > 0.0 || edifbrut > 0.0 || denshab > 0.0 || us > "") {
                txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;S&ograve;l d'aprofitament privat : " + solprivat.toFixed(2) + " %<br />";
                if (edifbrut > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edificabilitat bruta m&agrave;xima : " + edifbrut.toFixed(2) + " m<sup>2</sup>sostre/m<sup>2</sup>s&ograve;l<br />";
                if (denshab > 0.0)
                    txHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Densitat m&agrave;xima d'habitatges : " + denshab.toFixed(2) + " hab/ha<br />";
                if (us > "")
                    txHtml += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&Uacute;s global : ' + us + '<br />';
            }
            txHtml += "<br />";
        } else { pos.pos = oldPos; }

        // TRAMIT
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLTRAMIT17", "</PLTRAMIT17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<AMBIT>", "</AMBIT>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                tipus = Util.getBetweenI("<TIPUS>", "</TIPUS>", txElem);
                tramit = Util.getBetweenI("<TRAMIT>", "</TRAMIT>", txElem);
                aprov = Util.getBetweenI("<APROVACIO>", "</APROVACIO>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Planejament en tr&agrave;mit</h2>";
                    flag = false;
                }
                if (tipus > "")
                    txHtml += tipus + "<br />";
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (aprov > "")
                    txHtml += "Aprovaci&oacute; : " + tramit + " " + Util.formatDate(aprov) + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLTRAMIT17", "</PLTRAMIT17>", content, pos);
        }
        pos.pos = oldPos;

        // PLAESP
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLPLAESP17", "</PLPLAESP17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<PLAESPECIAL>", "</PLAESPECIAL>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                tipus = Util.getBetweenI("<TIPUS>", "</TIPUS>", txElem);
                tramit = Util.getBetweenI("<TRAMIT>", "</TRAMIT>", txElem);
                aprov = Util.getBetweenI("<APROVACIO>", "</APROVACIO>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Plans especials i de millora</h2>";
                    flag = false;
                }
//                if (tipus > "")
//                    txHtml += tipus + "<br />";
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (aprov > "")
                    txHtml += "Aprovaci&oacute; : " + tramit + " " + Util.formatDate(aprov) + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLPLAESP17", "</PLPLAESP17>", content, pos);
        }
        pos.pos = oldPos;

        // PLAPARC
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLPLAPARC17", "</PLPLAPARC17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<PLAPARCIAL>", "</PLAPARCIAL>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                tramit = Util.getBetweenI("<TRAMIT>", "</TRAMIT>", txElem);
                aprov = Util.getBetweenI("<APROVACIO>", "</APROVACIO>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Plans parcials</h2>";
                    flag = false;
                }
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (aprov > "")
                    txHtml += "Aprovaci&oacute; : " + tramit + " " + Util.formatDate(aprov) + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLPLAPARC17", "</PLPLAPARC17>", content, pos);
        }
        pos.pos = oldPos;

        // ESTDET
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLESTDET17", "</PLESTDET17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<ESTDETALL>", "</ESTDETALL>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                tramit = Util.getBetweenI("<TRAMIT>", "</TRAMIT>", txElem);
                aprov = Util.getBetweenI("<APROVACIO>", "</APROVACIO>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
                //perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Estudis de detall</h2>";
                    flag = false;
                }
                if (entorn !== 'internet' && enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (aprov > "")
                    txHtml += "Aprovaci&oacute; : " + tramit + " " + Util.formatDate(aprov) + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLESTDET17", "</PLESTDET17>", content, pos);
        }
        pos.pos = oldPos;

        // UNITAT
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLUNITAT17", "</PLUNITAT17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<UNITAT>", "</UNITAT>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                tipus = Util.getBetweenI("<TIPUS>", "</TIPUS>", txElem);
                tramit = Util.getBetweenI("<TRAMIT>", "</TRAMIT>", txElem);
                aprov = Util.getBetweenI("<APROVACIO>", "</APROVACIO>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Pol&iacute;gons d'actuaci&oacute;</h2>";
                    flag = false;
                }
                if (tipus > "")
                    txHtml += tipus + "<br />";
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (aprov > "")
                    txHtml += "Aprovaci&oacute; : " + tramit + " "+ Util.formatDate(aprov) + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLUNITAT17", "</PLUNITAT17>", content, pos);
        }
        pos.pos = oldPos;

        // MODPT
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLMODPT17", "</PLMODPT17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<MODPT>", "</MODPT>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                tipus = Util.getBetweenI("<TIPUS>", "</TIPUS>", txElem);
                tramit = Util.getBetweenI("<TRAMIT>", "</TRAMIT>", txElem);
                aprov = Util.getBetweenI("<APROVACIO>", "</APROVACIO>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Modificacions puntuals del POUM</h2>";
                    flag = false;
                }
                if (tipus > "")
                    txHtml += tipus + "<br />";
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (aprov > "")
                    txHtml += "Aprovaci&oacute; : " + tramit + " "+ Util.formatDate(aprov) + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLMODPT17", "</PLMODPT17>", content, pos);
        }
        pos.pos = oldPos;

        // CONVENI
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLCONVENI17", "</PLCONVENI17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<CONVENI>", "</CONVENI>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                tramit = Util.getBetweenI("<TRAMIT>", "</TRAMIT>", txElem);
                aprov = Util.getBetweenI("<APROVACIO>", "</APROVACIO>", txElem);
                resum = Util.getBetweenI("<RESUM>", "</RESUM>", txElem);
                parti = Util.getBetweenI("<PARTI>", "</PARTI>", txElem);
                vigent = Util.getBetweenI("<VIGENT>", "</VIGENT>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                //area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Conveni</h2>";
                    flag = false;
                }
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (resum > "")
                    txHtml += "Resum : " + resum + "<br />";
                if (parti > "")
                    txHtml += "Participant : " + parti + "<br />";
                if (aprov > "")
                    txHtml += "Aprovaci&oacute; : " + tramit + " " + Util.formatDate(aprov) + "<br />";
                if (vigent > "")
                    txHtml += "Vigent : " + vigent + "<br />";
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLCONVENI17", "</PLCONVENI17>", content, pos);
        }
        pos.pos = oldPos;

        // ELEMENTS CATALOGATS
        elcata = "";
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLELCATA17", "</PLELCATA17>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<ELCATA>", "</ELCATA>", txElem);
            if (codi > "") {
                elcata = codi;
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                prot = Util.getBetweenI("<NIVPROT>", "</NIVPROT>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                pesp = Util.getBetweenI("<PESP>", "</PESP>", txElem);
                enllacpe = Util.getBetweenI("<ENLLACPE>", "</ENLLACPE>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                txHtml += "<h2>B&eacute;ns arquitect&ograve;nics</h2>";
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (prot > "")
                    txHtml += "Protecci&oacute; : " + prot + "<br />";
                if (pesp > "")
                {
                    if (enllacpe > "")
                        txHtml += "<a href='#' onclick='window.open(\"" + enllacpe + "\")'><span style='color: blue; text-decoration:underline;'>" + pesp + "</span></a><br />";
                    else
                        txHtml += pesp + "<br />";
                }
//              txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//              txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
        } else { pos.pos = oldPos; }

        // ENTORN PROTECCIÓ
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLENTPR17", "</PLENTPR17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<ELCATA>", "</ELCATA>", txElem);
            if (codi > "" && codi != elcata) {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                prot = Util.getBetweenI("<NIVPROT>", "</NIVPROT>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                pesp = Util.getBetweenI("<PESP>", "</PESP>", txElem);
                enllacpe = Util.getBetweenI("<ENLLACPE>", "</ENLLACPE>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txEle)m);
                if (flag)
                {
                    flag = false;
                    txHtml += "<h2>Entorns de protecci&ograve; dels b&eacute;ns arquitect&ograve;nics</h2>";
                }
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (prot > "")
                    txHtml += "Protecci&oacute; : " + prot + "<br />";
                if (pesp > "")
                {
                    if (enllacpe > "")
                        txHtml += "<a href='#' onclick='window.open(\"" + enllacpe + "\")'><span style='color: blue; text-decoration:underline;'>" + pesp + "</span></a><br />";
                    else
                        txHtml += pesp + "<br />";
                }
//              txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//              txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLENTPR17", "</PLENTPR17>", content, pos);
        }
        pos.pos = oldPos;

        // FRONTS
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLFRONT17", "</PLFRONT17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<FRONT>", "</FRONT>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                prot = Util.getBetweenI("<NIVPROT>", "</NIVPROT>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                pesp = Util.getBetweenI("<PESP>", "</PESP>", txElem);
                enllacpe = Util.getBetweenI("<ENLLACPE>", "</ENLLACPE>", txElem);
//                perim = Number(Util.getBetweenI("<LENGTH>", "</LENGTH>", txElem));
                if (flag) {
                    txHtml += "<h2>Ambients i fronts</h2>";
                    flag = false;
                }
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (prot > "")
                    txHtml += "Protecci&oacute; : " + prot + "<br />";
                if (pesp > "")
                {
                    if (enllacpe > "")
                        txHtml += "<a href='#' onclick='window.open(\"" + enllacpe + "\")'><span style='color: blue; text-decoration:underline;'>" + pesp + "</span></a><br />";
                    else
                        txHtml += pesp + "<br />";
                }
//                txHtml += "Longitud : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLFRONT17", "</PLFRONT17>", content, pos);
        }
        pos.pos = oldPos;

        // ARQUEOLOGIA
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLARQUEO17", "</PLARQUEO17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<ARQUEO>", "</ARQUEO>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                prot = Util.getBetweenI("<NIVPROT>", "</NIVPROT>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                tipus = Util.getBetweenI("<TIPUS>", "</TIPUS>", txElem);
                categ = Util.getBetweenI("<CATEG>", "</CATEG>", txElem);
                pesp = Util.getBetweenI("<PESP>", "</PESP>", txElem);
                enllacpe = Util.getBetweenI("<ENLLACPE>", "</ENLLACPE>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>B&eacute;ns arqueol&ograve;gics</h2>";
                    flag = false;
                }
                if (tipus > "")
                    txHtml += tipus + "<br />";
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (prot > "")
                    txHtml += "Protecci&oacute; : " + prot + "<br />";
                if (categ > "")
                    txHtml += "Categoria : " + categ + "<br />";
                if (pesp > "")
                {
                    if (enllacpe > "")
                        txHtml += "<a href='#' onclick='window.open(\"" + enllacpe + "\")'><span style='color: blue; text-decoration:underline;'>" + pesp + "</span></a><br />";
                    else
                        txHtml += pesp + "<br />";
                }
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLARQUEO17", "</PLARQUEO17>", content, pos);
        }
        pos.pos = oldPos;

        // GEOLOGIA
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLGEOLOGIA17", "</PLGEOLOGIA17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<GEOLOGIA>", "</GEOLOGIA>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                pesp = Util.getBetweenI("<PESP>", "</PESP>", txElem);
                enllacpe = Util.getBetweenI("<ENLLACPE>", "</ENLLACPE>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Punts d'inter&egrave;s geol&ograve;gic</h2>";
                    flag = false;
                }
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (pesp > "")
                {
                    if (enllacpe > "")
                        txHtml += "<a href='#' onclick='window.open(\"" + enllacpe + "\")'><span style='color: blue; text-decoration:underline;'>" + pesp + "</span></a><br />";
                    else
                        txHtml += pesp + "<br />";
                }
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLGEOLOGIA17", "</PLGEOLOGIA17>", content, pos);
        }
        pos.pos = oldPos;

        // ARBRES I ARBREDES
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLARBRE17", "</PLARBRE17>", content, pos);
        flag = true;
        while (txElem > "") {
            codi = Util.getBetweenI("<ARBRE>", "</ARBRE>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                observ = Util.getBetweenI("<OBSERV>", "</OBSERV>", txElem);
                pesp = Util.getBetweenI("<PESP>", "</PESP>", txElem);
                enllacpe = Util.getBetweenI("<ENLLACPE>", "</ENLLACPE>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (flag) {
                    txHtml += "<h2>Arbres i arbredes protegits</h2>";
                    flag = false;
                }
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += codi + " - " + nom + "<br />";
                if (observ > "")
                    txHtml += observ + "<br />";
                if (pesp > "")
                {
                    if (enllacpe > "")
                        txHtml += "<a href='#' onclick='window.open(\"" + enllacpe + "\")'><span style='color: blue; text-decoration:underline;'>" + pesp + "</span></a><br />";
                    else
                        txHtml += pesp + "<br />";
                }
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
            oldPos = pos.pos;
            txElem = Util.getBetweenI("<PLARBRE17", "</PLARBRE17>", content, pos);
        }
        pos.pos = oldPos;

        // MASIES
        oldPos = pos.pos;
        txElem = Util.getBetweenI("<PLELCATA17", "</PLELCATA17>", content, pos);
        if (txElem > "") {
            codi = Util.getBetweenI("<MASIA>", "</MASIA>", txElem);
            if (codi > "") {
                nom = Util.getBetweenI("<NOM>", "</NOM>", txElem);
                enllac = Util.getBetweenI("<ENLLAC>", "</ENLLAC>", txElem);
                pesp = Util.getBetweenI("<PESP>", "</PESP>", txElem);
                enllacpe = Util.getBetweenI("<ENLLACPE>", "</ENLLACPE>", txElem);
//                area = Number(Util.getBetweenI("<AREA>", "</AREA>", txElem));
//                perim = Number(Util.getBetweenI("<PERIMETER>", "</PERIMETER>", txElem));
                if (enllac > "")
                    txHtml += "<a href='#' onclick='window.open(\"" + enllac + "\")'><span style='color: blue; text-decoration:underline;'>" + codi + " - " + nom + "</span></a><br />";
                else
                    txHtml += "<h2>Masies i cases rurals</h2>";
                txHtml += codi + " - " + nom + "<br />";
                if (pesp > "")
                {
                    if (enllacpe > "")
                        txHtml += "<a href='#' onclick='window.open(\"" + enllacpe + "\")'><span style='color: blue; text-decoration:underline;'>" + pesp + "</span></a><br />";
                    else
                        txHtml += pesp + "<br />";
                }
//                txHtml += "&Agrave;rea : " + Math.round(area).toString() + " m<sup>2</sup><br />";
//                txHtml += "Per&iacute;metre : " + Math.round(perim).toString() + " m<br />";
                txHtml += "<br />";
            }
        } else { pos.pos = oldPos; }

        // posem el contingut al PopUp
        popupContent.innerHTML = txHtmlTit + '<div style="max-height: 400px; overflow-y: auto">' + txHtml + '</div>';
        popupOverlay.setPosition(c);
    } 

}
